import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Dialog from "@mui/material/Dialog";
import { useId } from "react";
import { GfgButton } from "@/components/ui/GfgButton";
import {
  CANCEL_LABEL,
  UNASSIGN_CONFIRM_TITLE,
  UNASSIGN_LABEL,
  unassignConfirmDescription,
} from "@/constants/adminCollections";

interface UnassignConfirmModalProps {
  productName: string;
  organizationName: string;
  onClose: () => void;
  /** Confirms the unassign. The modal never calls the API: the caller owns the mutation. */
  onConfirm: () => void;
  /** The DELETE is in flight: confirm is disabled and the dialog cannot be dismissed. */
  pending?: boolean;
}

export default function UnassignConfirmModal({
  productName,
  organizationName,
  onClose,
  onConfirm,
  pending = false,
}: UnassignConfirmModalProps) {
  const titleId = useId();

  return (
    <Dialog
      open
      aria-labelledby={titleId}
      onClose={pending ? undefined : onClose}
      disableEscapeKeyDown={pending}
      disableScrollLock
      maxWidth={false}
      slotProps={{
        paper: {
          sx: {
            borderRadius: "16px",
            border: "1px solid var(--color-smoke)",
            p: "20px",
            m: 2,
            width: 577,
            maxWidth: "calc(100vw - 32px)",
          },
        },
      }}
    >
      <div className="flex flex-col items-center gap-3">
        <div
          aria-hidden="true"
          className="flex h-[76px] w-[76px] items-center justify-center rounded-full bg-clear-dust"
        >
          <WarningAmberIcon sx={{ fontSize: 28, color: "var(--color-dark-dust)" }} />
        </div>
        <h2 id={titleId} className="text-center font-crimson text-[30px] text-rodeo-black">
          {UNASSIGN_CONFIRM_TITLE}
        </h2>
        <p className="text-center font-lato text-base text-graphite">
          {unassignConfirmDescription(productName, organizationName)}
        </p>
        <div className="mt-6 flex items-center gap-6">
          <GfgButton type="button" variant="secondary" disabled={pending} onClick={onClose}>
            {CANCEL_LABEL}
          </GfgButton>
          <GfgButton
            type="button"
            variant="danger"
            disabled={pending}
            onClick={() => {
              if (!pending) onConfirm();
            }}
          >
            {UNASSIGN_LABEL}
          </GfgButton>
        </div>
      </div>
    </Dialog>
  );
}
